import apiUrl from "../config/apiUrl";
import { WalletGenerateAddressModel } from "../models/request/WalletGenerateAddress.model";
import fetchUrl from "../utils/fetchUrl";
import { AxiosResponse } from "axios";
import { Terminal } from "../models/response/terminal.response";
import { IHttpResponse } from "../models/HttpResponse.model";
import { AvailableTerminalsRequest } from "../models/request/availableTerminals.model";
import {
  CoinWithdrawCancelRequest,
  CoinWithdrawListRequest,
  CoinWithdrawRequest,
} from "../models/request/coinWithdraw.model";
import {
  CoinWithdrawConfirmResponse,
  CoinWithdrawListItemResponse,
  CoinWithdrawResponse,
} from "../models/response/coinWithdraw.response";
import { WalletHistoryRequest } from "../models/request/walletHistory.model";
import { WalletHistoryResponse } from "../models/response/walletHistory.response";

export const WALLET_FIND_ALL_WITH_ZERO = async () => {
  return await fetchUrl({
    url: `${apiUrl}wallet/find-all`,
    method: "GET",
  });
};

// IMPORTANT: deprecated API
// TODO: remove deprecated API and its usages
export const WALLET_GENERATE_ADDRESS = async (
  data: WalletGenerateAddressModel
) => {
  return await fetchUrl({
    url: `${apiUrl}wallet/generate-address`,
    method: "POST",
    body: data,
  });
};

export const WALLET_FIND_ALL_TERMINALS = async (): Promise<
  IHttpResponse<Terminal[]>
> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/get-all-terminals`,
    method: "GET",
  });
};

export const WALLET_FIND_AVAILABLE_TERMINALS = async (
  data: AvailableTerminalsRequest
): Promise<IHttpResponse<Terminal[]>> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/get-available-terminals?currency=${data.currency}&amount=${data.amount}`,
    method: "GET",
  });
};

export const WALLET_COIN_WITHDRAW_REQUEST = async (
  data: CoinWithdrawRequest
): Promise<IHttpResponse<CoinWithdrawResponse>> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/coin-withdraw-request`,
    method: "POST",
    body: data,
  });
};

export const WALLET_COIN_WITHDRAW_CONFIRM = async (
  data: CoinWithdrawRequest
): Promise<IHttpResponse<CoinWithdrawConfirmResponse>> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/coin-withdraw-confirm`,
    method: "POST",
    body: data,
  });
};

export const WALLET_COIN_WITHDRAW_LIST = async (
  data: CoinWithdrawListRequest
): Promise<IHttpResponse<CoinWithdrawListItemResponse[]>> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/get-user-all-requests?userId=${data.userId}`,
    method: "GET",
    // body: data,
  });
};

export const WALLET_COIN_WITHDRAW_CANCEL = async (
  data: CoinWithdrawCancelRequest
): Promise<IHttpResponse<boolean>> => {
  return await fetchUrl({
    url: `${apiUrl}wallet/withdraw/coin-withdraw-cancel?refId=${data.refId}`,
    method: "POST",
    // body: data,
  });
};

export const WALLET_HISTORY = async (
  data: WalletHistoryRequest
): Promise<IHttpResponse<WalletHistoryResponse>> => {
  let query = `periodType=${data.periodType}`;
  if (data.currency) {
    query += `&currency=${data.currency}`;
  }

  return await fetchUrl({
    url: `${apiUrl}wallet/history-asset-value?${query}`,
    method: "GET",
  });
};
